import React, { Component } from "react";
import PropTypes from "prop-types";
import { isEmpty, noop, map } from "lodash";
import { Link } from "react-router-dom";
import { normalizeAmount, formatData } from "../../utils/transformer.util";
import { Button, Select } from "../../components/base/index";
import { JADWAL_MATPEL_LIST_TABLE_FIELDS } from "../../constants/Student/student.constant";
import ReactToPrint from 'react-to-print';
import ReactExport from 'react-export-excel';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

const initialContent = {
  loading: true,
  list: [],
  currentPage: 1,
  total: 1,
  totalPage: 1,
  error: false,
};

export default class DataJadwalMatpelDetails extends Component {
  constructor(props) {
    super(props);
    this._onSearchContent = this._onSearchContent.bind(this);
    this._onClickAdd = this._onClickAdd.bind(this);
    this._onClickCetak = this._onClickCetak.bind(this);
    this._onFormChange = this._onFormChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._renderButtons = this._renderButtons.bind(this);
    this._getParamOptionsAcademics = this._getParamOptionsAcademics.bind(this);
    this.onClickEdit = this.onClickEdit.bind(this);
    this._onChangeFilter = this._onChangeFilter.bind(this);
    // this._getPrmLevels = this._getPrmLevels.bind(this);
    this._onClickDetails = this._onClickDetails.bind(this);
    this._onClickBack = this._onClickBack.bind(this);
    this._getPeriodsOptions = this._getPeriodsOptions.bind(this);

    const { user } = this.props;
    const { school_unit } = user;
    const { levels_id } = school_unit;

    this.state = {
      page: 1,
      selected: {},
      content: initialContent,
      unchecked: {},
      filters: {},
      list: [],
      form: {
        value: {
          levels_id,
          classrooms: [],
          levels: [],
          classrooms_id: "",
          listjadwal: [],
          listDetails: [],
          user_id: user.id,

        },
        error: {
          classrooms: "",
          levels: "",
        },
      },
      param: {},
      filtered: false,
    };
  }

  componentDidMount() {
     const { user, location } = this.props;
     const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { organizations_id, user_group } = user;
    const { content, form, filters } = this.state;
    // console.log(data)
    //   if (isEdit && data) {
    //   this._onSearchContentDetails(data);
    // }
    let savedForm = JSON.parse(window.localStorage.getItem('JadwalMapelForm')) || '';
    let savedFilters = JSON.parse(window.localStorage.getItem('JadwalMapelFilters')) || filters;
    if (savedForm != '' && user.id != savedForm.value.user_id) {
      savedForm = '';
      savedFilters = filters;
    }
     this._initializeData(savedFilters);
    if (savedForm != '') {
      this.setState(prevState => ({
        ...prevState,
        form: {
          ...prevState.form,
          value: {
            ...prevState.form.value,
            units_id: savedFilters.units_id ? savedFilters.units_id : '',
          },
        },
        filters: {
          ...prevState.filters,
          units_id: savedFilters.units_id ? savedFilters.units_id : '',
          // entrance_year : savedFilters.entrance_year,
        },
      }));

    }
     if (user_group.name === 'pusat' || user_group.name === 'pengurus' ) {
      console.log(savedFilters)
      console.log(savedForm)
        this._getPeriodsOptions({ units_id: savedFilters.units_id?savedFilters.units_id : ''});
      }
    // this._getPrmLevels({ filters: {units_id: [school_unit.id], organizations_id: organizations_id } });
  }

   async _initializeData(savedFilters = {}) {
    const { user } = this.props;
    const { content } = this.state;
    const { school_unit, user_group } = user;

    if (user_group.name !== 'pusat' || user_group.name !== 'pengurus') {
      await this._getPeriodsOptions({ units_id: school_unit.id });
      this._onSearchContent();
    } else {
      this.setState(prevState => ({
        filters: {
          ...prevState.filters,
          // entrance_year: savedFilters.entrance_year,
        },
      }),
      () => {
        // commonActions.setLoading({ show: true });
        this._onSearchContent();
      });
    }
  }


  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickAdd() {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      isEdit: true,
    });
  }

  onClickEdit(val) {
    const { history } = this.props;
    history.push("/dashboard/pengaturan/tambah-jadwal-matpel", {
      data: val,
      isEdit: true,
    });
  }

  async _getPrmLevels(filters = {}) {
    const { getPrmLevels, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { units_id, levels_id } = school_unit;
    const res = await getPrmLevels(filters);
    filters.organizations_id = organizations_id;

    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        levels: res,
      },
    }));
  }

  _onClickCetak() {
    const { history } = this.props;
    history.push(
      "/dashboard/kurikulum/mata-pelajaran/cetak/jadwal-mata-pelajaran"
    );
  }

    async _getPeriodsOptions(filters = {}) {
      const { getPeriodsOptions } = this.props;
      const res = await getPeriodsOptions(filters);
  
      map(res, (data, idx) => {
        const date = new Date();
        const start_date = new Date(data.attributes.start_date);
        if (date > start_date) {
          // tahun ajaran sekarang
          this.setState(prevState => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                periods_id: data.value,
              },
            },
            filters: {
              ...prevState.filters,
              period: data.value,
            },
          }));
        }
      });
  
      this.setState(prevState => ({
        ...prevState,
        param: {
          ...prevState.param,
          periods: res,
        },
      }));
    }

  async _onClickDetails(val, idx) {
    const { history } = this.props;

    this._onSearchContentDetails(val);
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page + 1,
      data_idx: idx,
    }));
    history.go(0);
  }

  _onClickBack() {
    window.scrollTo(0, 0);
    this.setState((prevState) => ({
      page: prevState.page - 1,
    }));
  }

  _onFormChange(event) {
    const { name, value, dataset, checked, type } = event.target;
    const {
      inputType = "text",
      inputArray = false,
      arrayPosition = 0,
      fieldName,
    } = dataset;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => {
        let newList = [];
        let newListError = [];
        let formattedValue = value;

        if (inputType === "number") {
          formattedValue = normalizeAmount(value);
        }
        if (inputArray) {
          if (type === "checkbox") {
            formattedValue = checked;
          }
          newList = prevState.form.value[fieldName];
          newListError = prevState.form.error[fieldName];
          newList[arrayPosition][name] = formattedValue;
          if (name === "code_of_account") {
            newList[arrayPosition].isCredit = value.type;
          }
          if (!isEmpty(newListError[arrayPosition])) {
            newListError[arrayPosition][name] = "";
          }
        }
        return {
          form: {
            value: {
              ...prevState.form.value,
              ...(inputArray
                ? { [fieldName]: newList }
                : { [name]: formattedValue }),
            },
            error: {
              ...prevState.form.error,
              ...(inputArray ? { [fieldName]: newListError } : { [name]: "" }),
            },
          },
        };
      },
      () => {
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            levels_id: value,
            organizations_id,
          });
        }
      }
    );
  }

  async _getParamOptionsAcademics(type, filters = {}) {
    const { getParamOptionsAcademics, user } = this.props;
    const { organizations_id, school_unit } = user;
    const { levels_id } = school_unit;

    if (type === "classrooms" || type === "classrooms") {
      filters.organizations_id = organizations_id;
      filters.units_id = school_unit.id;
    } else {
      delete filters.organizations_id;
    }
    const res = await getParamOptionsAcademics(filters, type);
    this.setState((prevState) => ({
      ...prevState,
      param: {
        ...prevState.param,
        [type]: res,
      },
    }));
  }

  async _onSearchContent(params = {}) {
    const { filters, form } = this.state;
    const { value } = form;
    const { period } = filters;
    const {
      location, getLevels, getclassrooms, user,
    } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    this.setState(
      {
        content: initialContent,
      },
      async () => {
        try {
          const { handleListReportDetailsSchedule, user } = this.props;
          const { organizations_id, school_unit, user_group } = user;
          const { units_id } = school_unit;
// console.log(data)
          const result = await handleListReportDetailsSchedule({
            ...params,
            organizations_id,
            units_id: user_group.name=='pusat' || user_group.name === 'pengurus'?data.units_id:school_unit.id,
            classrooms_id: data.classrooms_id,
            periods_id: data.periods_id,
            filters,
          });
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: result,
              },
            },
          }));
        } catch (err) {
          // if (this.isMount) {
          this.setState((prevState) => ({
            ...prevState,
            form: {
              ...prevState.form,
              value: {
                ...prevState.form.value,
                listDetails: [],
              },
            },
          }));
        }
        // }
      }
    );
  }

  // async _onSearchContentDetails(params = {}) {
  //   const { filters, form } = this.state;
  //   const { value } = form;
  //   const { period } = filters;
  //   const {
  //     location, getLevels, getclassrooms, user,
  //   } = this.props;
  //   const { state = {} } = location;
  //   const { isEdit = false, data } = state;
  //   this.setState(
  //     {
  //       content: initialContent,
  //     },
  //     async () => {
  //       try {
  //         const { handleListDetailsSchedule, user } = this.props;
  //         const { organizations_id, school_unit } = user;
  //         const { units_id } = school_unit;

  //         const result = await handleListDetailsSchedule({
  //           ...params,
  //           organizations_id,
  //           units_id: school_unit.id,
  //           // classrooms_id: classrooms_id,
  //           periods_id: period,

  //           filters,
  //         });
  //         this.setState((prevState) => ({
  //           ...prevState,
  //           form: {
  //             ...prevState.form,
  //             value: {
  //               ...prevState.form.value,
  //               listDetails: result,
  //             },
  //           },
  //         }));
  //       } catch (err) {
  //         // if (this.isMount) {
  //         this.setState((prevState) => ({
  //           ...prevState,
  //           form: {
  //             ...prevState.form,
  //             value: {
  //               ...prevState.form.value,
  //               listDetails: [],
  //             },
  //           },
  //         }));
  //       }
  //       // }
  //     }
  //   );
  // }

  async onClickDelete(id) {
    const { handleDeleteScheduleSubject } = this.props;
    const res = await handleDeleteScheduleSubject(id);
    if (res) {
      this._onSearchContent();
    }
  }

  _renderButtons(data) {
    const { user } = this.props;
    const { user_group } = user;
    const button = {};

    return (
      <td>
        <div className="table__actions">
          <Button onClick={() => this.onClickEdit(data)} title="Edit" />
          <Button onClick={() => this._onClickDetails(data)} title="Lihat Detail" />
        </div>
      </td>
    );
  }

  onSubmit(e) {
    e.preventDefault();
    // const { form} = this.state;
    const { form } = this.state;
    const { handleAddBudget, history, user } = this.props;
    const { workingUnit, prm_school_units_id } = user;

    let unit_id = prm_school_units_id;

    if (unit_id === null && workingUnit && workingUnit.id) {
      unit_id = workingUnit.id;
    }
    handleAddBudget(form.value, history.goBack, unit_id);
    // handleAddBudget(form.value, plafon, history.goBack, unit_id);
    // handleAddBudget(form.value, history.goBack, unit_id);
  }


  daysLabel() {
    const { form } = this.state;
    const { listDetails } = form.value;
    const rows = (listDetails && listDetails.row) || [];

    let uniqueDays = [];

    rows.forEach(item => {
      item.days.forEach(day => {
        if (!uniqueDays.some(d => d.day_id === day.day_id)) {
          uniqueDays.push(day);
        }
      });
    });


    // const dayHeaders = uniqueDays.map(day => (
    //   <th key={`day_${day.day_id}`} colSpan={2}>
    //     {day.day_name}
    //   </th>
    // ));
    const dayHeaders = uniqueDays
  .sort((a, b) => {
    if (a.day_id === 1) return 1;  // a adalah Minggu → letakkan setelah b
    if (b.day_id === 1) return -1; // b adalah Minggu → letakkan setelah a
    return a.day_id - b.day_id;    // urutkan lainnya secara normal
  })
  .map(day => (
    <th key={`day_${day.day_id}`} colSpan={2}>
      {day.day_name}
    </th>
  ));


    // console.log(uniqueDays)
    


    const subHeaders = uniqueDays.flatMap(day => [
      <th style={{width:'5%'}} key={`km_${day.day_id}`}>Mata Pelajaran</th>,
      <th style={{width:'5%'}} key={`kg_${day.day_id}`}>Guru</th>,
    ]);

    return (
      <>
        <tr>
          <th rowSpan={2}>JP</th>
          <th rowSpan={2} style={{width:'5%'}}>Pukul</th>
          {dayHeaders}
        </tr>
        <tr>{subHeaders}</tr>
      </>
    );
  }

  // renderTableBody() {
  //   const { form } = this.state;
  //   const { listDetails } = form.value;
  //   const rows = (listDetails && listDetails.row) || [];

  //   // Pastikan urutan hari sama dengan header
  //   let uniqueDays = [];

  //   rows.forEach(item => {
  //     item.days.forEach(day => {
  //       if (!uniqueDays.some(d => d.day_id === day.day_id)) {
  //         uniqueDays.push(day);
  //       }
  //     });
  //   });

  //   // console.log(uniqueDays.length)

  //   let lengthData = uniqueDays.length + 2
  //   console.log(lengthData)
  //   return rows.map((item, rowIndex) => (
  //     <tr key={rowIndex} style={{textAlign: "center"}}>
  //       <td>{item.jp}</td>
  //       <td>{item.hour}</td>
  //       {uniqueDays.map(day => {
  //         const dayData = item.days.find(d => d.day_id === day.day_id) || {};
  //         // if(dayData.km == 'IST'){
  //         //   return (
  //         //     <>
  //         //     <td colSpan={}></td>
  //         //     </>
  //         //   )
  //         // }
  //         return (
  //           <>
  //             <td>{dayData.km !== undefined ? dayData.km+'-'+dayData.km_name : '-'}</td>
  //             <td>{dayData.kg !== undefined ? dayData.kg+'-'+dayData.kg_name : '-'}</td>
  //           </>
  //         );
  //       })}
  //     </tr>
  //   ));
  // }

  renderTableBody() {
  const { form } = this.state;
  const { listDetails } = form.value;
  const rows = (listDetails && listDetails.row) || [];

  // Kumpulkan semua hari unik
  let uniqueDays = [];

  rows.forEach(item => {
    item.days.forEach(day => {
      if (!uniqueDays.some(d => d.day_id === day.day_id)) {
        uniqueDays.push(day);
      }
    });
  });

  // 🔽 Sortir hari: Minggu (day_id = 1) selalu di akhir
  uniqueDays.sort((a, b) => {
    if (a.day_id === 1) return 1;
    if (b.day_id === 1) return -1;
    return a.day_id - b.day_id;
  });

  let lengthData = uniqueDays.length + 2;
  console.log(lengthData);

  return rows.map((item, rowIndex) => (
    <tr key={rowIndex} style={{ textAlign: "center" }}>
      <td>{item.jp}</td>
      <td>{item.hour}</td>
      {uniqueDays.map(day => {
        const dayData = item.days.find(d => d.day_id === day.day_id) || {};
        return (
          <>
            <td>{dayData.km !== undefined ? `${dayData.km}-${dayData.km_name}` : '-'}</td>
            <td>{dayData.kg !== undefined ? `${dayData.kg}-${dayData.kg_name}` : '-'}</td>
          </>
        );
      })}
    </tr>
  ));
}




  _onChangeFilter(e) {
    const { target } = e;
    const { value, name } = target;
    const { user } = this.props;
    const { organizations_id } = user;
    this.setState(
      (prevState) => ({
        ...prevState,
        filters: {
          ...prevState.filters,
          [name]: value,
        },
      }),
      () => {
         window.localStorage.setItem('JadwalMapelForm',
        JSON.stringify(this.state.form));
      window.localStorage.setItem('JadwalMapelFilters',
        JSON.stringify(this.state.filters));
        if (name === "levels_id") {
          this._getParamOptionsAcademics("classrooms", {
            filters: { levels_id: value, organizations_id },
          });
        }
        this._onSearchContent();
        this._onSearchContentDetails();
      }
    );
  }


  render() {
    const { form, content, param, filters, page } = this.state;
    const { value } = form;
    const { listjadwal, listDetails } = form.value;
    const { user, location } = this.props;
    const { state = {} } = location;
    const { isEdit = false, data } = state;
    const { classrooms_id = "", period } = filters;
    const { handleGetKelas, handleDeleteKelas, coa, classrooms } = this.props;
    const prm_period = param.periods ? param.periods : '';
    const period_label = prm_period ? prm_period.find(i => i.value == period) ? prm_period.find(i => i.value == period).label : '' : '';

     const componentRef = React.createRef();
        const printTest = `
        @media print {
          @page {
            page-break-inside: avoid;
          }
          * {
            -webkit-print-color-adjust: exact;
          }
        }`;
    return (

      <div className="add-budget">
        <div className="student-list__header">
          {/* <div className="student-list__button">
            <Select
              type="text"
              name="levels_id"
              label="Unit"
              placeholder="Pilih Unit"
              data={param.levels}
              disabled
              value={form.value.levels_id}
              onChange={this._onFormChange}
              error={form.error.levels_id || ""}
            />
          </div> */}
          <div className="student-list__button">
             <Select
              name="period"
              label="Tahun Ajaran"
              placeholder="Pilihan"
              onChange={this._onChangeFilter}
              data={param.periods}
              value={filters.period}
              disabled
            />
          </div>
        </div>
        <br></br>
            <div className="beginning-balance__button-wrapper">
             <ReactToPrint
                pageStyle={printTest}
                onBeforeGetContent={() => new Promise((resolve) => {
                  setTimeout(() => {
                    this.setState({ isPrint: false },
                      resolve);
                  }, 500);
                })}
                onAfterPrint={() => this.setState({ isPrint: true })}
                trigger={() => (
                  <Button title="Cetak" />
                )}
                content={() => componentRef.current}
              />
  &nbsp;
                  <div style={{ marginLeft: '0rem' }} className="student-list__button">
                    <ReactHTMLTableToExcel
                      id="export-to-xls-button"
                      className="button "
                      table="printmapel"
                      filename={`Data Jadwal Pelajaran Kelas ${data.class_name}`}
                      sheet={data.class_name}
                      buttonText="Unduh ke Excel"
                    />
                  </div>
            </div>
            <form ref={componentRef}>
             <table className="laporan-ki4__table-test" style={{ width: 'unset' }} >
                <tr>
                  <td>Data Jadwal Mata Pelajaran Kelas {data.class_name}</td>
                </tr>
                <tr>
                  <td>Tahun Ajaran {period_label}</td>
                </tr>
          </table>
              
            <div className="student-list__button2">
              <div className="fund-request__content">
                <table className="tablespp" id="printmapel" style={{width:'250%'}} >
                  <thead>
                  {this.daysLabel()}
                  </thead>
                  <tbody>
                   {this.renderTableBody()}
                  </tbody>
                </table>
              </div>
            </div>
          </form>

      </div>
    );
  }
}
DataJadwalMatpelDetails.propTypes = {
  handleListClassData: PropTypes.func,
  handleGetStudent: PropTypes.func,
  handleDeleteStudent: PropTypes.func,
  history: PropTypes.object.isRequired,
};
DataJadwalMatpelDetails.defaultProps = {
  handleListClassData: noop,
  handleGetStudent: noop,
  handleDeleteStudent: noop,
};
